export default "__VITE_ASSET__DC72i3l9__"